/* This example requires Tailwind CSS v2.0+ */
import { Popover, Transition } from '@headlessui/react'


// const navigation = [
//   { name: 'World Cup', href: '#', current: true },
//   { name: 'Premier League', href: '#', current: false },
//   { name: 'NFL', href: '#', current: false },
//   { name: 'NBA', href: '#', current: false },
// ]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
export default function Example() {
  return (
              
    <Popover className="relative bg-white justify:center">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex items-center justify-between border-b-2 border-gray-100 py-3 md:justify-center md:space-x-10">


          <a href="/worldcup" className="text-base font-medium text-gray-500 hover:text-gray-900">
            World Cup
          </a>
          <a href="#" className="text-base font-medium text-gray-500 hover:text-gray-900">
            Premier League
          </a>
          <a href="#" className="text-base font-medium text-gray-500 hover:text-gray-900">
            NFL
          </a>
          <a href="#" className="text-base font-medium text-gray-500 hover:text-gray-900">
            NBA
          </a>
        </div>
      </div>


    </Popover>
  )
}
